import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function Reveal({ children, delay = 0, className = "" }) {
  const { ref, inView } = useScrollAnimation();
  return (
    <div
      ref={ref}
      className={`reveal ${inView ? "visible" : ""} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </div>
  );
}
